import React, { createContext, useEffect, useState } from "react";

const UserContext = createContext();

const UserProvider = ({ children }) => {
    const initialState = {
        user:{},
        campanias: [],
    };

    const [state, setState] = useState(initialState);
    
    const handleState = (newState)=>{
        setState(newState)
    }
    
    const resetState = ()=>{
        setState({...initialState})
    }

    const setUser = (newUser)=>{
        setState({...state,user:newUser})

    }

    const setCampanias = (newCampanias)=>{
        setState({...state,campanias:newCampanias})

    }

    
    // useEffect(() => {
    //     console.log('👉 - state', state)
    // }, [state]);

    return (
        <UserContext.Provider
            value={{
                state,
                setState:handleState,
                resetState,
                user: state.user,
                setUser,
                campanias:state.campanias,
                setCampanias
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

export { UserProvider, UserContext };



// WEBPACK FOOTER //
// ./src/context/UserContext.js